
import React from "react";
import { Box, Button, IconButton, TextField, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";

export default function ProjectFacts({ value = [], onChange }) {
    const addFact = () => {
        onChange([...value, { label: "", value: "" }]);
    };

    const updateFact = (index, field, newValue) => {
        onChange(
            value.map((fact, i) =>
                i === index
                    ? { ...fact, [field]: newValue }
                    : fact
            )
        );
    };

    const removeFact = (index) => {
        onChange(value.filter((_, i) => i !== index));
    };

    return (
        <Box sx={{ mt: 3, mb: 3 }}>
            <Typography variant="subtitle1" sx={{ mb: 2 }}>
                Stichpunkte
            </Typography>

            {value.map((fact, index) => (
                <Box
                    key={index}
                    sx={{
                        display: "flex",
                        gap: 1,
                        alignItems: "center",
                        mb: 1.5
                    }}
                >
                    <TextField
                        label="Bezeichnung"
                        placeholder="z. B. Ort"
                        value={fact.label}
                        onChange={(e) =>
                            updateFact(index, "label", e.target.value)
                        }
                        size="small"
                        fullWidth
                    />

                    <TextField
                        label="Wert"
                        placeholder="z. B. München"
                        value={fact.value}
                        onChange={(e) =>
                            updateFact(index, "value", e.target.value)
                        }
                        size="small"
                        fullWidth
                    />

                    <IconButton
                        color="error"
                        onClick={() => removeFact(index)}
                        aria-label="Stichpunkt entfernen"
                    >
                        <DeleteIcon />
                    </IconButton>
                </Box>
            ))}

            <Button
                variant="outlined"
                startIcon={<AddIcon />}
                onClick={addFact}
                sx={{ mt: 1 }}
            >
                Stichpunkt hinzufügen
            </Button>
        </Box>
    );
}
